
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2qdw9_1ftgu_9",
  "refresh": "awsui_refresh_2qdw9_1ftgu_45",
  "root-no-actions": "awsui_root-no-actions_2qdw9_1ftgu_45",
  "root-variant-h2": "awsui_root-variant-h2_2qdw9_1ftgu_48",
  "root-variant-h3": "awsui_root-variant-h3_2qdw9_1ftgu_48",
  "root-has-description": "awsui_root-has-description_2qdw9_1ftgu_48",
  "root-variant-h1": "awsui_root-variant-h1_2qdw9_1ftgu_57",
  "main": "awsui_main_2qdw9_1ftgu_67",
  "no-wrap": "awsui_no-wrap_2qdw9_1ftgu_77",
  "main-variant-h1": "awsui_main-variant-h1_2qdw9_1ftgu_83",
  "actions": "awsui_actions_2qdw9_1ftgu_91",
  "actions-centered": "awsui_actions-centered_2qdw9_1ftgu_96",
  "actions-variant-h1": "awsui_actions-variant-h1_2qdw9_1ftgu_99",
  "actions-variant-h2": "awsui_actions-variant-h2_2qdw9_1ftgu_103",
  "actions-variant-h3": "awsui_actions-variant-h3_2qdw9_1ftgu_107",
  "additional-title-content": "awsui_additional-title-content_2qdw9_1ftgu_123",
  "title": "awsui_title_2qdw9_1ftgu_132",
  "title-variant-h1": "awsui_title-variant-h1_2qdw9_1ftgu_137",
  "title-variant-h2": "awsui_title-variant-h2_2qdw9_1ftgu_144",
  "title-variant-h3": "awsui_title-variant-h3_2qdw9_1ftgu_150",
  "title-in-expandable-section": "awsui_title-in-expandable-section_2qdw9_1ftgu_163",
  "virtual-space": "awsui_virtual-space_2qdw9_1ftgu_188",
  "info": "awsui_info_2qdw9_1ftgu_194",
  "description": "awsui_description_2qdw9_1ftgu_198",
  "description-variant-h1": "awsui_description-variant-h1_2qdw9_1ftgu_205",
  "description-variant-h2": "awsui_description-variant-h2_2qdw9_1ftgu_209",
  "description-variant-h3": "awsui_description-variant-h3_2qdw9_1ftgu_216",
  "heading": "awsui_heading_2qdw9_1ftgu_227",
  "heading-variant-h1": "awsui_heading-variant-h1_2qdw9_1ftgu_252",
  "heading-variant-h2": "awsui_heading-variant-h2_2qdw9_1ftgu_257",
  "heading-variant-h3": "awsui_heading-variant-h3_2qdw9_1ftgu_262",
  "heading-text": "awsui_heading-text_2qdw9_1ftgu_268",
  "heading-text-variant-h1": "awsui_heading-text-variant-h1_2qdw9_1ftgu_271",
  "heading-text-variant-h2": "awsui_heading-text-variant-h2_2qdw9_1ftgu_280",
  "heading-text-variant-h3": "awsui_heading-text-variant-h3_2qdw9_1ftgu_289",
  "counter": "awsui_counter_2qdw9_1ftgu_299"
};
  